import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import {
  GET_ADMIN_INTERNAL_USERS,
  GET_ALL_ADMIN_EMPLOYEES,
  CREATE_ADMIN_INTERNAL_USER,
  MODIFY_ADMIN_INTERNAL_USER,
  DELETE_ADMIN_INTERNAL_USER,
  CREATE_BULK_ADMIN_INTERNAL_USER,
  RESEND_ADMIN_INTERNAL_USER_INVITE,
  MODIFY_BULK_ADMIN_INTERNAL_USER,
  DELETE_BULK_ADMIN_INTERNAL_USER,
  BULK_EDIT_ADMIN_INTERNAL_USERS,
  GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS,
  PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT,
} from "./actionTypes"

import {
  getAdminInternalUsersSuccess,
  getAdminInternalUsersError,
  getAllAdminEmployeesSuccess,
  getAllAdminEmployeesError,
  createAdminInternalUserSuccess,
  createAdminInternalUserError,
  updateAdminInternalUserSuccess,
  updateAdminInternalUserError,
  deleteAdminInternalUserSuccess,
  deleteAdminInternalUserError,
  createBulkAdminInternalUserSuccess,
  createBulkAdminInternalUserError,
  resendAdminInternalUserInviteError,
  resendAdminInternalUserInviteSuccess,
  updateBulkAdminInternalUserSuccess,
  deleteBulkAdminInternalUserSuccess,
  bulkEditAdminInternalUsersSuccess,
  bulkEditAdminInternalUsersError,
  getAdminInternalUsersBulkEditStatusSuccess,
  getAdminInternalUsersBulkEditStatusError,
  previewAdminInternalUsersBulkEditSuccess,
  previewAdminInternalUsersBulkEditError,
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericGetRequest_2, genericPostRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { sf_fetch } from "helpers/sf_fetch"
import { responseErrorChecker } from "helpers/sf_utils"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { USER_INVITE_STR } from "common/sf_strings"

function* onGetAdminInternalUsers(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {...action.payload?.queryParams},
      {
        Authorization: user.token,
      }
    )
    yield put(getAdminInternalUsersSuccess(response, action.paginated))
  } catch (error) {
    yield put(getAdminInternalUsersError(error))
  }
}

function* onGetAllAdminEmployees(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_all_admin_employees`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getAllAdminEmployeesSuccess(response))
  } catch (error) {
    yield put(getAllAdminEmployeesError(error))
  }
}

function* onCreateAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(createAdminInternalUserError(error))
  }
}

function* onCreateBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(createBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(createBulkAdminInternalUserError(error))
  }
}

function* onUpdateAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_user.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(updateAdminInternalUserError(error))
  }
}

function* onUpdateBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_users.map(admin_user => admin_user.id).join(',')}?bulk=1`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json',
        }
      }
    )
    yield put(updateBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(updateAdminInternalUserError(error))
  }
}

function* onDeleteBulkAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.admin_users.map(admin_user => admin_user.id).join(',')}?bulk=1`,
      {
        headers: {
          Authorization: user.token,
        }
      }
    )
    yield put(deleteBulkAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(deleteAdminInternalUserError(error))
  }
}

function* onDeleteteAdminInternalUser(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericDeleteRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteAdminInternalUserSuccess(response))
  } catch (error) {
    yield put(deleteAdminInternalUserError(error))
  }
}

function* onResendAdminInternalUserInvite(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_manage_employees/resend_invite/${action.payload.id}`,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(resendAdminInternalUserInviteSuccess(response))
  } catch (error) {
    yield put(resendAdminInternalUserInviteError({type: USER_INVITE_STR.RESEND_ERROR_TYPE, message: `Failed to resend invitation to ${action.payload.email}`}))
  }
}

// User Management bulk edits run through the shared, async bulk edit flow
// (same as the CPA Optimizer), via its admin-token endpoints.
const ADMIN_BULK_EDITS_URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_bulk_edits`
const ADMIN_INTERNAL_USER_BULK_EDIT_TARGET_KEY = "admin_internal_user"
const ACTIVE_BULK_EDIT_STATUSES = ["queued", "in_progress", "cancellation_requested", "processing"]

const normalizeBulkEditJob = job => {
  if (!job) return null

  // cancellation_requested still holds the lock until the worker
  // acknowledges it, so the page must stay locked for it too.
  const status = ["queued", "in_progress", "cancellation_requested"].includes(job.status)
    ? "processing"
    : job.status
  return { ...job, status }
}

// select_all targets every user matching the active filters (all pages);
// otherwise only the explicitly picked ids.
const buildBulkEditPayload = payload => ({
  target_key: ADMIN_INTERNAL_USER_BULK_EDIT_TARGET_KEY,
  selection: payload?.select_all
    ? { mode: "filters", filters: payload?.filters || {} }
    : { mode: "ids", ids: Array.isArray(payload?.ids) ? payload.ids : [] },
  changes: payload?.changes || {},
  ...(payload?.idempotency_key ? { idempotency_key: payload.idempotency_key } : {}),
})

const adminAuthHeaders = () => ({ Authorization: bsh_getAdminUserDetails().token })

// preview renders its payload at the top level rather than under `data`,
// so genericPostRequest's `.data` unwrap can't be used for it.
const postRequestRaw = async (url, init) => {
  const response = await sf_fetch(url, { method: "POST", ...init })
  const responseText = await responseErrorChecker(response)
  return JSON.parse(responseText)
}

function* onBulkEditAdminInternalUsers(action) {
  try {
    const payload = buildBulkEditPayload(action.payload)
    if (payload.selection.mode === "ids" && payload.selection.ids.length === 0) {
      yield put(bulkEditAdminInternalUsersError(new Error("No users selected for bulk edit")))
      return
    }
    const response = yield call(genericPostRequest, ADMIN_BULK_EDITS_URL, {
      body: JSON.stringify(payload),
      headers: { ...adminAuthHeaders(), "Content-Type": "application/json" },
    })
    yield put(bulkEditAdminInternalUsersSuccess(normalizeBulkEditJob(response)))
  } catch (error) {
    yield put(bulkEditAdminInternalUsersError(error))
  }
}

function* onPreviewAdminInternalUsersBulkEdit(action) {
  try {
    const payload = buildBulkEditPayload(action.payload)
    if (payload.selection.mode === "ids" && payload.selection.ids.length === 0) {
      yield put(previewAdminInternalUsersBulkEditError(new Error("No users selected for bulk edit")))
      return
    }
    const response = yield call(postRequestRaw, `${ADMIN_BULK_EDITS_URL}/preview`, {
      body: JSON.stringify(payload),
      headers: { ...adminAuthHeaders(), "Content-Type": "application/json" },
    })
    yield put(previewAdminInternalUsersBulkEditSuccess(response))
  } catch (error) {
    yield put(previewAdminInternalUsersBulkEditError(error))
  }
}

// Follows the job this page started, or otherwise asks whether another
// admin's User Management bulk edit currently holds the lock.
function* onGetAdminInternalUsersBulkEditStatus() {
  try {
    const headers = adminAuthHeaders()
    const currentJob = yield select(state => state?.AdminManageInternalUsers?.bulk_edit_job)
    let response = null

    if (currentJob?.id && ACTIVE_BULK_EDIT_STATUSES.includes(currentJob.status)) {
      response = yield call(genericGetRequest_2, `${ADMIN_BULK_EDITS_URL}/${currentJob.id}`, {}, headers)
    } else {
      const lockStatus = yield call(
        genericGetRequest_2,
        `${ADMIN_BULK_EDITS_URL}/lock_status`,
        { target_key: ADMIN_INTERNAL_USER_BULK_EDIT_TARGET_KEY },
        headers
      )
      if (lockStatus?.active_request_id) {
        try {
          response = yield call(genericGetRequest_2, `${ADMIN_BULK_EDITS_URL}/${lockStatus.active_request_id}`, {}, headers)
        } catch (_error) {
          // Still locked even if the job details can't be read; stay locked.
          response = { id: lockStatus.active_request_id, status: lockStatus.status || "in_progress" }
        }
      }
    }

    yield put(getAdminInternalUsersBulkEditStatusSuccess(normalizeBulkEditJob(response)))
  } catch (error) {
    yield put(getAdminInternalUsersBulkEditStatusError(error))
  }
}

function* AdminManageInternalUsersSaga() {
  yield takeLatest(GET_ADMIN_INTERNAL_USERS, onGetAdminInternalUsers)
  yield takeEvery(GET_ALL_ADMIN_EMPLOYEES, onGetAllAdminEmployees)
  yield takeEvery(CREATE_ADMIN_INTERNAL_USER, onCreateAdminInternalUser)
  yield takeEvery(CREATE_BULK_ADMIN_INTERNAL_USER, onCreateBulkAdminInternalUser)
  yield takeEvery(MODIFY_ADMIN_INTERNAL_USER, onUpdateAdminInternalUser)
  yield takeEvery(MODIFY_BULK_ADMIN_INTERNAL_USER, onUpdateBulkAdminInternalUser)
  yield takeEvery(DELETE_BULK_ADMIN_INTERNAL_USER, onDeleteBulkAdminInternalUser)
  yield takeEvery(DELETE_ADMIN_INTERNAL_USER, onDeleteteAdminInternalUser)
  yield takeEvery(RESEND_ADMIN_INTERNAL_USER_INVITE, onResendAdminInternalUserInvite)
  yield takeEvery(BULK_EDIT_ADMIN_INTERNAL_USERS, onBulkEditAdminInternalUsers)
  yield takeLatest(GET_ADMIN_INTERNAL_USERS_BULK_EDIT_STATUS, onGetAdminInternalUsersBulkEditStatus)
  yield takeLatest(PREVIEW_ADMIN_INTERNAL_USERS_BULK_EDIT, onPreviewAdminInternalUsersBulkEdit)
}

export default AdminManageInternalUsersSaga;
